<template>
  <component :is="htmlTag" ref="title" class="ellipsis tooltip" @mouseenter="checkEllipsis">
    {{ content }}
    <span class="tooltip__arrow" v-if="isEllipsis" :style="tooltipStyle"></span>
    <span class="tooltip__content p-4px" v-if="isEllipsis" :style="tooltipStyle">{{ content }}</span>
  </component>
</template>

<script>
export default {
  name: "EllipsisTitle",
  props: {
    htmlTag: {
      type: String,
      default: "p"
    },
    content: String
  },
  data: () => ({
    isEllipsis: false,
    tooltipX: 0,
    tooltipY: 0
  }),
  computed: {
    titleTooltip() {
      return this.isEllipsis ? this.content : false;
    },
    tooltipStyle() {
      return {
        top: `${this.tooltipY}px`,
        left: `${this.tooltipX}px`
      };
    }
  },
  methods: {
    checkEllipsis() {
      this.$nextTick(() => {
        const titleElement = this.$refs.title;
        if (titleElement) {
          this.isEllipsis = titleElement.offsetWidth < titleElement.scrollWidth;
          if (this.isEllipsis) {
            const rect = titleElement.getBoundingClientRect();
            this.tooltipX = (rect.left + rect.right) / 2;
            this.tooltipY = rect.bottom;
          }
        } else {
          this.isEllipsis = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tooltip {
  $zIndex: 1000;
  $arrowHeight: 4px;
  @mixin tooltip-item {
    transform: translateX(-50%);
    display: none;
    position: fixed;
    z-index: $zIndex;
  }

  &__content {
    font-size: 0.7em;
    background: $dark3;
    color: $textDarkModeHigh;
    max-width: 400px;
    border-radius: $radius;
    margin-top: $arrowHeight;
    white-space: normal; 
    word-break: break-all;
    overflow-wrap: break-word;
    @include tooltip-item;
  }

  &__arrow {
    width: 0;
    height: 0;
    border-left: $arrowHeight solid transparent;
    border-right: $arrowHeight solid transparent;
    border-bottom: $arrowHeight solid $dark3;
    border-top: 0;
    @include tooltip-item;
  }

  &:hover {
    .tooltip {
      &__content, &__arrow {
        display: block;
      }
    }
  }
}
</style>
